import React from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export const Breadcrumbs = ({ items, light = false }) => (
  <nav
    data-testid="breadcrumbs"
    aria-label="Breadcrumb"
    className={`flex flex-wrap items-center gap-2 text-xs tracking-[0.14em] uppercase ${light ? "text-stone-300" : "text-stone-500"}`}
  >
    {items.map((it, i) => (
      <React.Fragment key={it.label}>
        {i > 0 && <CaretRight size={10} className={light ? "text-stone-400" : "text-stone-400"} />}
        {it.to && i < items.length - 1 ? (
          <Link data-testid={`breadcrumb-${i}`} to={it.to} className={`transition-colors ${light ? "hover:text-stone-50" : "hover:text-stone-900"}`}>
            {it.label}
          </Link>
        ) : (
          <span data-testid={`breadcrumb-${i}`} className={`${light ? "text-stone-50" : "text-stone-800"} truncate max-w-[60vw] sm:max-w-none`}>{it.label}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumbs;
